import AppProvider from '@/components/providers/app-provider';
import React from 'react';
import { createRoot } from 'react-dom/client';

export const initReactWithStrictMode = () => {
  return createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <AppProvider />
    </React.StrictMode>
  );
};

export const initReact = () => {
  return createRoot(document.getElementById('root')!).render(<AppProvider />);
};
